import ReportsAddress from './ReportsAddress'

export default ReportsAddress
